import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, List, Paragraph } from '@digdir/designsystemet-react';
import layout from '../../HRDashboard/hmsPage.module.css';

const DUTIES = ['follow', 'plan', 'sign', 'speak'] as const;

export const RoleCard = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <section
      aria-labelledby="vo-role"
      className={layout.sideCard}
      data-gap="sm"
    >
      <Heading level={2} data-size="xs" id="vo-role">
        {t('safetyRep.work.role.title')}
      </Heading>
      <Paragraph data-size="sm">{t('safetyRep.work.role.intro')}</Paragraph>
      <List.Unordered data-size="sm">
        {DUTIES.map((duty) => (
          <List.Item key={duty}>
            {t(`safetyRep.work.role.items.${duty}`)}
          </List.Item>
        ))}
      </List.Unordered>
    </section>
  );
};
